import React, { useState } from 'react';

import { FreecodePlayer } from 'components/FreecodePlayer/freecodePlayer';
import { executorDecompress } from 'functions/executorDecompress';

export default function RankListPlayAgainst({ testImplementation, contestId, opponentId }) {
  const [levelToRun, setLevelToRun] = useState(0);

  const humanInputProps = {
    testId: testImplementation.test,
    testImplId: testImplementation._id,
    contestId: contestId,
    opponentId: opponentId,
  };

  return (
    <FreecodePlayer
      testImplementation={testImplementation}
      levels={executorDecompress(testImplementation.generated?.peekResponse)}
      levelToRun={levelToRun}
      setLevelToRun={setLevelToRun}
      humanInputProps={humanInputProps}
    />
  );
}
